export const lossReasons = [
  { label: 'عدم المتابعة', en: 'No follow-up', value: 31 },
  { label: 'اعتراض على السعر', en: 'Price objection', value: 24 },
  { label: 'تأخر الرد', en: 'Delayed response', value: 18 },
  { label: 'عدم توفر موعد مناسب', en: 'No suitable time', value: 11 },
  { label: 'اختار منافسًا', en: 'Chose a competitor', value: 9 },
  { label: 'أسباب أخرى', en: 'Other reasons', value: 7 }
];

export const treatments = [
  { name: 'زراعة الأسنان', en: 'Dental Implants', lost: 11, value: 38500 },
  { name: 'تقويم الأسنان', en: 'Orthodontics', lost: 7, value: 31500 },
  { name: 'ابتسامة / فينير', en: 'Smile / Veneers', lost: 9, value: 27000 },
  { name: 'تبييض الأسنان', en: 'Teeth Whitening', lost: 14, value: 8400 },
  { name: 'خدمات أخرى', en: 'Other Services', lost: 18, value: 12000 }
];

export const funnel = [
  { label: 'العملاء الجدد', en: 'New Leads', count: 250 },
  { label: 'تم التواصل', en: 'Contacted', count: 218 },
  { label: 'مؤهلون', en: 'Qualified', count: 142 },
  { label: 'تم الحجز', en: 'Booked', count: 91 },
  { label: 'حضر الموعد', en: 'Attended', count: 73 },
  { label: 'وافق على العلاج', en: 'Accepted Treatment', count: 41 }
];

export const leads = [
  { id: '1042', date: '26 أغسطس', service: 'زراعة الأسنان', source: 'Instagram', value: 4500, status: 'مفقود', reason: 'اعتراض على السعر', followups: 1, owner: 'سارة', score: 91, last: 'منذ 6 أيام' },
  { id: '1049', date: '25 أغسطس', service: 'تقويم الأسنان', source: 'Google Ads', value: 6000, status: 'مفقود', reason: 'عدم المتابعة', followups: 1, owner: 'نورة', score: 88, last: 'منذ 4 أيام' },
  { id: '1054', date: '24 أغسطس', service: 'ابتسامة / فينير', source: 'Website', value: 3000, status: 'ناجح', reason: '—', followups: 2, owner: 'سارة', score: 0, last: 'منذ 3 أيام' },
  { id: '1061', date: '23 أغسطس', service: 'تبييض الأسنان', source: 'Referral', value: 700, status: 'مفقود', reason: 'تأخر الرد', followups: 0, owner: 'ليان', score: 84, last: 'منذ 8 أيام' },
  { id: '1068', date: '21 أغسطس', service: 'زراعة الأسنان', source: 'WhatsApp', value: 4000, status: 'مفقود', reason: 'عدم توفر موعد مناسب', followups: 2, owner: 'نورة', score: 72, last: 'منذ 11 يومًا' },
  { id: '1073', date: '20 أغسطس', service: 'تقويم الأسنان', source: 'Instagram', value: 6000, status: 'ناجح', reason: '—', followups: 3, owner: 'ليان', score: 0, last: 'منذ 12 يومًا' },
  { id: '1081', date: '18 أغسطس', service: 'ابتسامة / فينير', source: 'Google Ads', value: 3000, status: 'مفقود', reason: 'اختار منافسًا', followups: 1, owner: 'سارة', score: 67, last: 'منذ 14 يومًا' }
];

export const sources = [
  { name: 'Instagram', leads: 84, conversion: 18, revenue: 67200, leakage: 24100 },
  { name: 'Google Ads', leads: 68, conversion: 22, revenue: 74500, leakage: 19800 },
  { name: 'WhatsApp', leads: 46, conversion: 26, revenue: 43800, leakage: 12300 },
  { name: 'Referral', leads: 31, conversion: 35, revenue: 39600, leakage: 7100 },
  { name: 'Website', leads: 21, conversion: 19, revenue: 21800, leakage: 5150 }
];

export const uploads = [
  { name: 'August Leads.csv', date: '28 أغسطس 2026', leads: 250, status: 'مكتمل' },
  { name: 'July Leads.csv', date: '1 أغسطس 2026', leads: 231, status: 'مكتمل' },
  { name: 'June Leads.csv', date: '2 يوليو 2026', leads: 219, status: 'مكتمل' }
];

export const monthly = [
  { month: 'مارس', value: 42000 },
  { month: 'أبريل', value: 51000 },
  { month: 'مايو', value: 47500 },
  { month: 'يونيو', value: 59000 },
  { month: 'يوليو', value: 58500 },
  { month: 'أغسطس', value: 68450 }
];